export const buildRetrospective = (dataset, profiles, studentId) => {
  const profile = profiles.get(studentId);
  if (!profile) return null;

  const classmates = [...profiles.values()].filter((entry) => entry.clasa === profile.clasa);
  const classMean = classmates.length
    ? classmates.reduce((sum, entry) => sum + entry.totalCredits, 0) / classmates.length
    : 0;

  if (profile.totalCredits === 0 && classMean === 0) return null;

  const aboveClassMean = profile.totalCredits >= classMean;

  const moduleAverages = {};
  dataset.modules.forEach((module) => {
    const values = classmates.map((entry) => entry.creditsByModule[module.cod_module] || 0);
    moduleAverages[module.cod_module] = values.length
      ? values.reduce((sum, value) => sum + value, 0) / values.length
      : 0;
  });

  const underrepresented = dataset.modules
    .filter(
      (module) =>
        (profile.creditsByModule[module.cod_module] || 0) < (moduleAverages[module.cod_module] || 0) &&
        (moduleAverages[module.cod_module] || 0) > 0,
    )
    .map((module) => module.cod_module);

  const classmateIds = new Set(classmates.map((entry) => entry.studentId));
  const popularity = new Map();
  dataset.requests
    .filter(
      (request) =>
        request.status === 'validat' &&
        request.an_scolar === profile.schoolYear &&
        request.nume_activitate &&
        classmateIds.has(request.id_elev),
    )
    .forEach((request) => {
      const entry = popularity.get(request.nume_activitate) || {
        name: request.nume_activitate,
        students: new Set(),
      };
      entry.students.add(request.id_elev);
      popularity.set(request.nume_activitate, entry);
    });

  const doneNames = new Set(profile.activityNames);
  const missedActivities = [...popularity.values()]
    .filter((entry) => !doneNames.has(entry.name))
    .map((entry) => ({ name: entry.name, classmates: entry.students.size }))
    .sort((a, b) => b.classmates - a.classmates)
    .slice(0, 5);

  const lines = [
    `In ${profile.schoolYear} ai avut ${profile.totalCredits} credite, ${aboveClassMean ? 'peste' : 'sub'} media clasei (${classMean.toFixed(1)}).`,
    underrepresented.length
      ? `Module subreprezentate fata de medie: ${underrepresented.join(', ')}.`
      : 'Ai acoperit toate modulele cel putin la nivelul mediei clasei.',
    missedActivities.length
      ? `Activitati populare ratate in clasa: ${missedActivities.map((entry) => `${entry.name} (${entry.classmates} colegi)`).join('; ')}.`
      : 'Ai participat la activitatile populare ale clasei.',
  ];

  return {
    studentId,
    schoolYear: profile.schoolYear,
    totalCredits: profile.totalCredits,
    classMean,
    aboveClassMean,
    moduleAverages,
    underrepresented,
    missedActivities,
    lines,
  };
};
